import { ClbTooltip } from "@celebration/react/ClbTooltip/ClbTooltip";
import type { TooltipProps } from "@components/contracts/Tooltip.types";
import type React from "react";

export const CelebrationTooltip: React.FC<TooltipProps> = ({
  children,
  ...props
}) => <ClbTooltip {...props}>{children}</ClbTooltip>;
